import { motion } from "motion/react";

export function TOCItem({ number, title, delay = 0 }) {
  return (
    <motion.div
      initial={{ opacity: 0, x: -20 }}
      whileInView={{ opacity: 1, x: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, delay, ease: "easeOut" }}
      whileHover={{ x: 4, transition: { duration: 0.2 } }}
      className="group flex items-center gap-3 md:gap-6 rounded-lg bg-[rgba(255,255,255,0.05)] item-border border-[rgba(255,255,255,0.1)] px-3 py-2 md:px-4 md:py-3 cursor-pointer transition-colors hover:border-[rgba(253,91,56,0.5)]"
    >
      <span className="text-[#fd5b38] shrink-0">{number}</span>
      <span className="text-[#d1d5dc] text-sm md:text-base">{title}</span>
    </motion.div>
  );
}
